import { useSelector } from "react-redux"
import { useState, useEffect } from "react"
import { isNextApp } from "utils-lib/isNextApp"

/**
 * Custom hook to check if the application has been rehydrated.
 *
 * This hook is particularly useful in Next.js applications to determine if the app is ready after rehydration.
 * It uses the `react-persist` library to check the rehydration status from the Redux state.
 *
 * @returns {Object} An object containing:
 * - `isReady` {boolean}: A boolean indicating if the app is ready after rehydration.
 */
export const useRehydratedCheck = () => {
  const isNextAppCheck = isNextApp
  const [isReady, setIsReady] = useState(!isNextAppCheck)

  // react-perist sets this to true when it's done rehydrating, it's a more accurate check than tracking this ourselves with a separate redux state and ensures consistent behavior across the app
  const isRehydrated = useSelector((state) => state._persist?.rehydrated)

  useEffect(() => {
    if (!isReady && isRehydrated && isNextAppCheck) {
      setIsReady(true)
    }
  }, [isRehydrated])

  return { isReady }
}
